module.exports = __webpack_public_path__ + "static/media/man.3b7d6f60.png";